import PointsInput from './PointsInput';
import PointsInputContainer from './PointsInput.container';

export default PointsInputContainer(PointsInput);
